export const setURLParams = (param, param_value) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(param, param_value);
    const newUrl = window.location.pathname + '?' + urlParams.toString();
    window.history.pushState({}, '', newUrl);
}